<template>
  <div>
    <b-table-simple class="p-table">
      <thead>
        <tr>
          <td class="td-header">Status</td>
          <td class="td-header">Saída</td>
          <td class="td-header">Paciente/Fornecedor</td>
          <td class="td-header">Profissional</td>
          <td class="td-header">Tipo de Saída</td>
          <td class="td-header">Valor total de custo</td>
          <td class="td-header">Valor total de venda</td>
          <td class="td-header" colspan="2"></td>
        </tr>
      </thead>
      <tbody v-for="(entry, index) in entries" :key="index" class="td-body">
        <tr>
          <td class="td-body td-simple" :style="{ color: (entry.status === 'Pendente' ? '#FF6B00' : 'var(--type-active)') }">
            <strong>{{ entry.status }}</strong>
          </td>
          <td class="td-body td-simple">
            {{ 
              new Date(entry.date).toLocaleDateString('pt-BR', { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone })
            }}
          </td>
          <td class="td-body td-simple">
            {{ 
              (entry.warehouse_product_transactions.length > 0 && entry.warehouse_product_transactions[0].warehouse_output?.patient?.name) || 
              entry.provider?.name || 
              '-'
            }}
          </td>
          <td class="td-body td-simple">
            {{ entry.warehouse_product_transactions.length > 0 && entry.warehouse_product_transactions[0].warehouse_output?.person ? entry.warehouse_product_transactions[0].warehouse_output?.person?.name : '-' }}
          </td>
          <td class="td-body td-simple">
            {{ TipoSaidaEnum[entry.type.toUpperCase()] !== undefined ? TipoSaidaEnum[entry.type.toUpperCase()] : '-' }}
          </td>
          <td class="td-body td-simple">{{ parseNumberToMoney(calculateCost(entry.warehouse_product_transactions)) }}</td>
          <td class="td-body td-simple">{{ parseNumberToMoney(calculateTotal(entry.warehouse_product_transactions)) }}</td>
          <td class="td-body no-print">
            <div v-if="userHasPermission('EstSai3') || userHasPermission('EstSai4')" class="more-with-menu">
              <MoreVertical class="more-icon" />
              <div class="menu p-2">
                <b-button
                  v-can="'EstSai3'"
                  variant="link"
                  v-if="configuration.entries_outputs_editable"
                  @click="onEdit(entry)"
                >
                  Editar
                </b-button>
                <b-button
                  v-can="'EstSai3'"
                  variant="link"
                  v-if="configuration.entries_outputs_editable && entry.status === 'Pendente'"
                  @click="decreaseBatch(entry)"
                >
                  Efetuar Saída
                </b-button>
                <b-button
                  v-can="'EstSai4'"
                  variant="link remove mb-0"
                  @click="deleteClick(entry)"
                >
                  Excluir
                </b-button>                
              </div>             
            </div>
          </td>
          <td class="td-body no-print">
            <div v-if="userHasPermission('EstSai3') || userHasPermission('EstSai4')" class="more-with-menu">
              <div class="actions">
                <b-button
                  v-b-toggle="`collapse-${entry.id}-${index}`"
                  @click="rotateIcon(entry.id)"
                  class="toggle-btn"
                >
                  <ChevronDown class="chevron" :class="{ 'rotated': rotatedList.includes(entry.id) }" />
                </b-button>
              </div>
            </div>
          </td>
        </tr>
        <tr class="collapsable-row">
          <td colspan="8" class="p-0">
            <b-collapse ref="accordion" :id="`collapse-${entry?.id}-${index}`" class="collapse">
              <OutputTransactionsTable
                :transactions="entry.warehouse_product_transactions"
                @openModalKit="openModalKitDetail"
              />
            </b-collapse>
          </td>
        </tr>
      </tbody>
    </b-table-simple>

    <EmptyTableResults
      emptyMessage="Cadastre uma saída para visualizá-la aqui."
      :loading="loading"
      :length="entries ? entries.length : 0"
      :hasFilter="hasFilter"
    />

    <DeleteModal
      type="movimentação de saída"
      article="a"
      :description="toDelete ? toDelete.product?.name : ''"
      :confirmedDelete="confirmedDelete"
    />

    <KitDetailModal
      identifier="kit-detail-modal"
      :batchCode="selectedBatchCode"
    />
  </div>
</template>
<script>
import { userHasPermission, getCurrentClinic } from '@/utils/localStorageManager'
import { parseNumberToMoney } from '@/utils/moneyHelper';
import { normalizeProductNumber } from '@/utils/product-helper'
import { TipoSaidaEnum } from '@/utils/warehouse';
import api from '@/modules/warehouse/api'
import { EventBus } from '@/utils/eventBus'

export default {
  props: {
    transactions: { type: Array, required: false },
    entries: { type: Array, required: true },
    onEdit: Function,
    onDelete: Function,
    loading: Boolean,
    hasFilter:  { validate: v => true },
  },
  created() {
    this.getWarehouseConfigurations()
  },
  data() {
    return {
      clinic: getCurrentClinic(),
      configuration: {},
      toDelete: null,
      TipoSaidaEnum,
      rotatedList: [],
      selectedBatchCode: ''
    }
  },
  components: {
    DeleteModal: () => import('@/components/General/DeleteModal'),
    EmptyTableResults: () => import('@/components/General/EmptyTableResults'),
    ChevronDown: () => import('@/assets/icons/chevron-down.svg'),
    MoreVertical: () => import('@/assets/icons/more-vertical.svg'),
    OutputTransactionsTable: () => import('@/components/Warehouse/OutputTransactionsTable.vue'),
    'KitDetailModal': () => import('@/components/Warehouse/KitDetailModal'),
    // Appointment: () => import('@/assets/icons/appointment.svg'),
    // BatchDetail: () => import('@/components/Warehouse/BatchDetail'),
    // Exam: () => import('@/assets/icons/exam.svg'),
    // Procedure: () => import('@/assets/icons/procedure.svg'),
    // Sale: () => import('@/assets/icons/sale.svg'),
    // Surgical: () => import('@/assets/icons/surgical.svg'),
    // Telemedicine: () => import('@/assets/icons/telemedicine.svg'),
    // Trash: () => import('@/assets/icons/trash.svg'),
    // Consumption: () => import('@/assets/icons/consumption.svg'),
    // Courtesy: () => import('@/assets/icons/courtesy.svg'),
    // Icon: () => import('@/components/General/Icon'),
    // HelpCircle: () => import('@/assets/icons/info-circle.svg'),
  },
  methods: {
    userHasPermission,
    parseNumberToMoney,
    normalizeProductNumber,
    parseType(type, procedure) {
      if (type === 'PROCEDURE') {
        return procedure?.name ?? '-';
      }

      const tipoSaida = TipoSaidaEnum[type.toUpperCase()];
      return tipoSaida !== undefined ? tipoSaida : '-';
    },
    deleteClick(transaction) {
      this.toDelete = transaction;
      this.$bvModal.show('delete-modal');
    },
    confirmedDelete(confirm) {
      if (confirm) {
        this.onDelete(this.toDelete)
      }
      this.toDelete = null;
      this.$bvModal.hide('delete-modal');
    },
    getWarehouseConfigurations() {
      this.api.getWarehouseConfigurations(this.clinic.id)
      .then(res => {
        this.configuration = res.data;
      })
      .catch(err => this.$toast.error(err.message))
    },
    isExpired(date) {
      const now = new Date();
      const expirationDate = new Date(date);
      return now.getTime() > expirationDate.getTime();
    },
    isToExpire(date, expirationNotice) {
      if (this.isExpired(date)) return false;
      const expirationNoticeDate = new Date();
      expirationNoticeDate.setDate(expirationNoticeDate.getDate() + expirationNotice);
      const expirationDate = new Date(date);
      return expirationNoticeDate.getTime() > expirationDate.getTime();
    },
    rotateIcon(id) {
      this.rotatedList.includes(id)
        ? this.rotatedList.pop(id)
        : this.rotatedList.push(id)
    },
    calculateCost(transactions){
      return transactions.reduce((acc, transaction) =>
        acc + ((transaction.purchase_price ? transaction.purchase_price : 0) * transaction.quantity), 0
      )
    },
    calculateTotal(transactions){
      return transactions.reduce((acc, transaction) =>
        acc + ((transaction.sale_price ? transaction.sale_price : 0) * transaction.quantity), 0
      )
    },
    decreaseBatch(output){
      api.decreaseBatchOutput(output.id)
      .then(res => {
        this.$toast.success(res.data);
        EventBus.$emit('reloadProductOutputs');
      })
      .catch(err => this.$toast.error(err.message))
    },
    openModalKitDetail(batchId) {
      this.selectedBatchCode = batchId;
      this.$bvModal.show('kit-detail-modal');
    }
  },
}
</script>
<style lang="scss" scoped>
  .p-table {
    width: 100%;
    text-align: left;
    margin: 20px 0;

    .td-header {
      border-bottom: 1px dashed var(--neutral-300);
      background-color: var(--neutral-100);
      font-weight: 700;
      font-size: 14px;
      color: var(--type-active);
      border: none;
      padding: 10px;
    }
    .td-body {
      padding: 20px 10px;
      border-top: 1px dashed var(--neutral-300);
      font-weight: 600;
      font-size: 16px;
      color: var(--type-active);
    }
    .td-simple {
      font-weight: normal !important;
    }
    .procedure-text {
      max-width: 150px;
      margin-left: 10px;
    }
    .number {
      font-family: 'Red Hat Display';
      font-weight: 700;
      color: var(--neutral-500);
    }
    .trashed {
      text-decoration: line-through;
    }
    .more {
      svg {
        stroke: var(--neutral-500);
      }
    }
    .edit-text {
      font-size: 16px;
      font-weight: 600;
      color: var(--blue-500);
    }
    .delete-text {
      font-size: 16px;
      font-weight: 600;
      color: var(--states-error);
    }
    .trash {
      stroke: #FBA59D;
    }
    .icon {
      width: 24px;
      height: 24px;
    }
    .blue-icon {
      fill: #0C1D59;
    }
    
    .toggle-btn {
      margin-left: 8px;
      background: var(--blue-100);
      border: none;
      padding: 4px 4px !important;
    }

    .use-type {
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: 400;
    }
    .product-name {
      cursor: pointer;
    }
    .more-with-menu {
      width: 24px;
      height: 28px;
      position: relative;
      display: inline-block;

      .more-icon {
        width: 24px;
        height: 24px;
        stroke: var(--neutral-500);
        transition: all 0.5s;
        cursor: pointer;
      }

      .menu {
        position: absolute;
        top: 28px;
        right: 0;
        background: var(--neutral-000);
        border: 1px solid var(--neutral-200);
        box-sizing: border-box;
        box-shadow: 0px 4px 4px rgba(12, 29, 89, 0.1), 0px 4px 10px -8px rgba(12, 29, 89, 0.2);
        border-radius: 8px;
        opacity: 0;
        transition: all 0.5s;
        flex-direction: column;
        align-items: start;
        display: none;
        margin-top: -10px;

        .mtb-12 {
          margin: 12px 0;
        }

        .btn {
          font-family: 'Nunito Sans';
          font-style: normal;
          font-weight: 600;
          font-size: 16px;
          line-height: 150%;

          &.remove {
            color: var(--states-error);
          }

          &.btn-link {
            padding: 12px !important;
          }
        }
      }

      &:hover {
        .more-icon {
          transform: rotate(90deg);
        }

        .menu {
          opacity: 1;
          display: flex;
          z-index: 10;
        }
      }

      .chevron {
        width: 24px;
        height: 24px;
        transition: all 0.5s;
        stroke: var(--neutral-600);
        cursor: pointer;

        &.rotated {
          rotate: 180deg;
          transition: rotate 0.5s;
        }
      }

    }
  }
  .tooltip-product {
    text-align: left;
    font-size: 12px;

    .batch {
      font-size: 16px;
      font-weight: 600;
      color: var(--type-active);
    }
    .date {
      font-size: 14px;
      font-weight: 600;
      color: var(--type-active);
    }
    .danger {
      color: var(--states-error);
    }
    .warning {
      color: var(--orange);
    }
  }

  .help-icon {
    width: 22px;
    height: 22px;
    margin-right: 5px;
    stroke: var(--neutral-500);
  }
</style>
